<template>
 <!-- Slider main container -->
<div class="swiper-container">

    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
      <!-- Slides -->
      <slot></slot>
    </div>

    <!-- If we need pagination -->
    <div v-if="showPager" class="swiper-pagination"></div>

    <!-- If we need navigation buttons -->
    <div v-if="showNav" class="swiper-button-prev"></div>
    <div v-if="showNav" class="swiper-button-next"></div>

    <!-- If we need scrollbar -->
    <div v-if="showScroll" class="swiper-scrollbar"></div>

</div>
</template>

<script>
import Swiper from 'swiper'

export default {

  data () {
    return {
      defaultParams: {

        // Optional parameters
        loop: true,

        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        },

        // If we need navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        // If we need a scrollbar
        scrollbar: {
          el: '.swiper-scrollbar'
        }

      }
    }
  },

  props: {
    parameters: {
      required: false,
      type: Object,
      default () {
        return {}
      }
    },

    showPager: {
      required: false,
      type: Boolean,
      default: true
    },

    showNav: {
      required: false,
      type: Boolean,
      default: true
    },

    showScroll: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  computed: {
    swiperParams () {
      return Object.assign(this.defaultParams, this.parameters)
    }
  },

  mounted () {
    // eslint-disable-next-line
    const mySwiper = new Swiper('.swiper-container', this.swiperParams)
  }
}
</script>

<style lang="scss">
</style>
